import type IMediaClient from "@meeting/interfaces/IMediaClient";
import type ISnapshotCreateResult from "@meeting/interfaces/ISnapshotCreateResult";
import { API } from "./Api";

class BeaconMediaClient implements IMediaClient{
    async createSnapshot(conversationId: string, sessionId: string, blob: Blob): Promise<ISnapshotCreateResult> {
        let formData = new FormData();
			formData.append("snapshot", blob);

        // Send an HTTP POST request with the given form data as its body.
        let response = await fetch(new API().buildURL(`/public/snapshots/${conversationId}/`), {
            method: "POST",
            body: formData,
        });
        if(!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return response.json() as Promise<ISnapshotCreateResult>;
    }
    getSnapshot(token: string): Promise<ISnapshotCreateResult> {
        // beacon does not support getting snapshot
        throw new Error("Method not implemented.");
    }
    startRecording(conversationId: string, sessionId: string): Promise<void> {
        // beacon does not support starting recording
        throw new Error("Method not implemented.");
    }
    stopRecording(conversationId: string, sessionId: string): Promise<void> {
        // beacon does not support stopping recording
        throw new Error("Method not implemented.");
    }

}
export default BeaconMediaClient;
export { BeaconMediaClient };